import React, {useEffect, useRef, useState} from 'react';
const sitekey = process.env.REACT_APP_TURNSTILE_SITE_KEY;
let loader;
function loadTurnstile() {
  if (window.turnstile) return Promise.resolve(window.turnstile);
  if (!loader) loader = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
    script.async = true;
    script.onload = () => window.turnstile ? resolve(window.turnstile) : reject(new Error('Verification unavailable'));
    script.onerror = () => {script.remove(); loader = undefined; reject(new Error('Verification unavailable'));};
    document.head.appendChild(script);
  });
  return loader;
}
export default function Turnstile({onToken, resetKey}) {
  const container = useRef(null);
  const [error, setError] = useState('');
  useEffect(() => {
    onToken('');
    if (!sitekey) return undefined;
    let cancelled = false, widget;
    setError('');
    loadTurnstile().then(api => {
      if (cancelled) return;
      widget = api.render(container.current, {sitekey, action:'lead', size:'compact',
        callback:token => {setError('');onToken(token);},
        'expired-callback':() => onToken(''),
        'error-callback':() => {onToken('');setError('Security verification could not load. Check your connection and retry.');}
      });
    }).catch(() => {if (!cancelled) setError('Security verification is unavailable. Please reload the page or contact us by email.');});
    return () => {cancelled = true;if (widget !== undefined) window.turnstile?.remove(widget);};
  }, [onToken, resetKey]);
  if (!sitekey) return process.env.NODE_ENV === 'production' ? <p role="alert">Online requests are temporarily unavailable. Please contact info@technoration.net.</p> : null;
  return <div className="inquiry-verification"><div className="turnstile-frame" ref={container}/>{error && <p role="alert" className="form-error">{error}</p>}</div>;
}
